export default __webpack_public_path__ + "static/praxis-08cecb653a42ee808469c0d35ad16037.jpeg";